import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    getHeaderItem = (item, index) => {
        if (index === 0) {
            return (
                <li style={{ background: 'none', paddingLeft: '2px' }}>
                    <a href={item.url} target="_blank" key={index}>
                        {item.title}
                    </a>
                </li>
            );
        } else {
            return (
                <li>
                    <a href={item.url} target="_blank" key={index}>
                        {item.title}
                    </a>
                </li>
            );
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.headerContainer}>
                <ul className={styles.list_menu} id="gsList">
                    {content.nav.map((item, index) => this.getHeaderItem(item, index))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Header);
